<template>
  <div>
    <!-- {{ data }} -->
    <v-form-card
      v-if="data_object"
      :data="data"
      ref="form"
      :key="formKey"
      :panels="true"
      :submit_button_caption="'Save'"
      :onGetData="onGetData"
      :setTableProperties="setTableProperties"
      :caption="caption"
    >
    </v-form-card>
  </div>
</template>

<script>
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
Vue.use(VueAxios, axios);

// import * as fun from "../plugins/common";
// import * as charge from "../plugins/objects/charge";
// import VFormCard from "../components/FormCard"

export default {
  name: "Customer",
  components: {
    // VLoading: () => import("../components/Loading.vue"),
    // VPanels: () => import("../components/Panels.vue"),
    VFormCard: () => import("../components/FormCard.vue")
  },
  props: {},
  data() {
    return {
      object_name: "emover_customers",
      shipment_id: 0,
      caption: "eMover Customer",
      data_object: {},
      data: null,
      expanded: [],
      formKey: 0,
      required: [],
      model: null,
      chargeType: [],
      chargeTable: [],
      documentTemplates: []
    };
  },

  mounted() {
    this._id = this.$route.params.id;
    this.data = {
      object_name: this.object_name,
      object_id: this._id,
      single_record: true,
      // qry: { _id: this._id },
      portal_id: this.$session.get("portal_id"),
      additional_data: [{ obj_name: "document" }]
    };
    this.formKey = !this.formKey;
  },
  beforeDestroy() {},
  watch: {
    model: {
      handler: function(newValue, oldValue) {
        console.log(this.model, oldValue, newValue);
      },

      deep: true
    }
  },
  methods: {
    onLoadComponent(obj) {
      console.log(obj);
    },
    onDataChanged(model, valid) {
      console.log(model, valid);
      this.model = model;
    },
    onGetData(data_object) {
      this.model = data_object.model;
      this.chargeType = this.model.charge_category;
      this.documentTemplates = data_object.additional_model.document;
      this.data_object = data_object;
    },
    setTableProperties(e, model, data_object) {
      var that = this;
      console.log(model, data_object);
      // var that = this;
      // var charge_categorys = that.data_object.model.charge_category;
      // var materials = that.data_object.additional_model.material_list;

      switch (e.object_type) {
        case "emover_invoice":
          e["v-bind"].additionalData = that.documentTemplates;
          e["v-bind"].toolBarExpandedControls = [
            {
              comp: "send-letter",
              "v-bind": {
                model: that.model
                // onClick: function() {
                //   console.log(model);
                // },
                // onChange: function() {
                //   console.log("change");
                // },
                // btnProp: {
                //   right: true,
                //   color: "info",
                //   text: true,
                //   small: true,
                //   //   elevation: 3,
                // },
              }
            }
          ];
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style lang="css" scoped>
/* html {
  overflow: hidden !important;
}

.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
} */
</style>
